import vs from './default-raw-vs.glsl'
import fs from './scratch-three.glsl'

const ScratchShader = {
  uniforms: {
    tDiffuse: { value: null },
  },
  vertexShader: vs,
  fragmentShader: fs,
}

export { ScratchShader }
